import React from "react";
import {
    HighlightContainer,
    FirstContainer,
    FirstContentImage,
    DescriptionDiv,
    DescriptionSpan,
    DescriptionHeader,
    DescriptionHeaderLink,
    LinkText,
    SecondContainer,
    LeftPart,
    LeftPartInner,
    LeftPartImageContainer,
    ImageContainerLInk,
    LeftPartImage,
    LeftPartDescription,
    RightPart,
    RightPartInner,
    RightPartContainerLink,
    RightPartImage,
    RightImageTitle,
    RightImageText,
    Container,
} from "../../styles/HighLight";

// images
import basketImg from "assets/images/largeSec/basket.jpg";
import decorativeImg from "assets/images/largeSec/decorative.jpg";
import kitchenCollectionImg from "assets/images/largeSec/kitchenCollection.jpg";
import largeImg from "assets/images/largeSec/largeImg.jpg";
import rightLargeImg from "assets/images/largeSec/rightLargeImg.jpg";
import wallDecorImg from "assets/images/largeSec/wallDecor.jpg";
import { Link } from "react-router-dom";

function HighLight(props) {
    return (
        <HighlightContainer>
            <Container className="container">
                <FirstContainer>
                    <FirstContentImage src={largeImg} className="img-fluid" />
                    <DescriptionDiv>
                        <DescriptionSpan>UNEXAMPLED FINDS</DescriptionSpan>
                        <DescriptionHeader>
                            for a refined <br /> HOME…
                        </DescriptionHeader>
                        <DescriptionHeaderLink>
                            <LinkText>
                                Explore our unique accent pieces
                            </LinkText>
                        </DescriptionHeaderLink>
                    </DescriptionDiv>
                </FirstContainer>

                <SecondContainer>
                    <LeftPart>
                        <LeftPartInner>
                            <LeftPartImageContainer>
                                <ImageContainerLInk>
                                    <Link
                                        to="/shop/decorative-objects?id=10"
                                        className="text-decoration-none"
                                    >
                                        <LeftPartImage
                                            src={decorativeImg}
                                            className="img-fluid"
                                        />
                                        <LeftPartDescription>
                                            Decorative
                                        </LeftPartDescription>
                                    </Link>
                                </ImageContainerLInk>
                            </LeftPartImageContainer>

                            <LeftPartImageContainer>
                                <ImageContainerLInk>
                                    <Link
                                        to="/shop/baskets?id=8"
                                        className="text-decoration-none"
                                    >
                                        <LeftPartImage
                                            src={basketImg}
                                            className="img-fluid"
                                        />
                                        <LeftPartDescription>
                                            Baskets
                                        </LeftPartDescription>
                                    </Link>
                                </ImageContainerLInk>
                            </LeftPartImageContainer>
                        </LeftPartInner>

                        <LeftPartInner>
                            <LeftPartImageContainer>
                                <ImageContainerLInk>
                                    <Link
                                        to="/shop/kitchen-dining?id=14"
                                        className="text-decoration-none"
                                    >
                                        <LeftPartImage
                                            src={kitchenCollectionImg}
                                            className="img-fluid"
                                        />
                                        <LeftPartDescription>
                                            Kitchen Collections
                                        </LeftPartDescription>
                                    </Link>
                                </ImageContainerLInk>
                            </LeftPartImageContainer>

                            <LeftPartImageContainer>
                                <ImageContainerLInk>
                                    <Link
                                        to="/shop/wall-decor?id=15"
                                        className="text-decoration-none"
                                    >
                                        <LeftPartImage
                                            src={wallDecorImg}
                                            className="img-fluid"
                                        />
                                        <LeftPartDescription>
                                            Wall decor
                                        </LeftPartDescription>
                                    </Link>
                                </ImageContainerLInk>
                            </LeftPartImageContainer>
                        </LeftPartInner>
                    </LeftPart>

                    <RightPart>
                        <RightPartInner>
                            <RightPartContainerLink>
                                <RightPartImage
                                    src={rightLargeImg}
                                    className="img-fluid"
                                />
                            </RightPartContainerLink>
                            <RightImageTitle>
                                find your ultimate design style and refresh your
                                space
                            </RightImageTitle>
                            <RightImageText>
                                Ruhlistic is sure to blow your mind with unique
                                pieces for décor and home essentials that will
                                enhance your home's appeal and style
                            </RightImageText>
                        </RightPartInner>
                    </RightPart>
                </SecondContainer>
            </Container>
        </HighlightContainer>
    );
}

export default HighLight;
